import { Box } from "@mui/material";

interface IBybBackground {
  imageUrl: string;
}

const BybBackground = ({ imageUrl }: IBybBackground) => (
  <Box
    sx={theme => ({
      position: "absolute",
      inset: 0,
      background: `linear-gradient(to bottom,
        ${theme.palette.dsBase.v100}80 0%,
        ${theme.palette.dsBase.v100} 70%,
        ${theme.palette.dsBase.v100} 100%
      ), url('${imageUrl}')`,
      backgroundSize: "contain",
      backgroundPosition: "center top",
      backgroundRepeat: "no-repeat",
      width: "100%",
      height: "100%",
      zIndex: -1,
    })}
  />
);

export default BybBackground;
